import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { i18n } from '../i18n/nl';

/**
 * <embrace-ended-banner> — banner onderaan bij 'ended' sessie met download-knop.
 */
@customElement('embrace-ended-banner')
export class EmbraceEndedBanner extends LitElement {
  static override styles = css`
    :host { display: block; }

    .banner {
      padding: 12px 16px;
      background: var(--ec-surface-sunken);
      border-top: 1px solid var(--ec-border);
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .top {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .txt {
      flex: 1;
      font: 500 13px/1.35 var(--ec-font-family);
      color: var(--ec-text);
    }
    .txt small {
      display: block;
      color: #5E5F62;
      font-weight: 400;
      margin-top: 2px;
    }

    .actions {
      display: flex;
      gap: 8px;
    }

    button {
      flex: 1;
      border: 0;
      padding: 9px 12px;
      border-radius: 8px;
      cursor: pointer;
      font: 600 12px/1.2 var(--ec-font-family);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      transition: background var(--ec-duration-fast) var(--ec-ease-smooth);
    }
    button:focus-visible {
      outline: var(--ec-focus-ring-width) solid var(--ec-focus-ring);
      outline-offset: var(--ec-focus-ring-offset);
    }
    .primary {
      background: var(--ec-primary);
      color: #fff;
    }
    .primary:hover { background: #12265a; }
    .secondary {
      background: #fff;
      color: var(--ec-primary);
      border: 1px solid var(--ec-border);
    }
    .secondary:hover { background: var(--ec-surface-sunken); }
  `;

  override render() {
    return html`
      <div class="banner">
        <div class="top">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5E5F62" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 8v.01M11 12h1v4h1"/>
          </svg>
          <div class="txt">
            ${i18n.endedBanner.title}
            <small>${i18n.endedBanner.subtitle}</small>
          </div>
        </div>
        <div class="actions">
          <button class="secondary" @click=${this.download}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3v12m-5-5 5 5 5-5"/>
              <path d="M5 21h14"/>
            </svg>
            ${i18n.endedBanner.btnTranscript}
          </button>
          <button class="primary" @click=${this.closeConversation}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            ${i18n.endedBanner.btnClose}
          </button>
        </div>
      </div>
    `;
  }

  private download() {
    this.dispatchEvent(
      new CustomEvent('download-transcript', { bubbles: true, composed: true }),
    );
  }

  private closeConversation() {
    // Hergebruikt 'start-new-conversation'-event: handler in embrace-chat
    // dispatcht SESSION_RESET, wat alles wist (incl. pickedChannel) →
    // bezoeker komt op channel-picker / intake-form, niet automatisch
    // in een nieuwe sessie.
    this.dispatchEvent(
      new CustomEvent('start-new-conversation', { bubbles: true, composed: true }),
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'embrace-ended-banner': EmbraceEndedBanner;
  }
}
